import React from 'react';

import { Box, Typography, TypographyProps } from '@mui/material';

import { getSearchMatchSegments } from './searchMatchSegments';

export type HighlightSearchMatchProps = TypographyProps & {
  content: string;
  query: string;
};

export const HighlightSearchMatch: React.FC<HighlightSearchMatchProps> = ({
  content,
  query,
  ...typographyProps
}) => {
  const segments = getSearchMatchSegments(content, query);

  return (
    <Typography {...typographyProps}>
      {segments.map((segment, index) =>
        segment.highlight ? (
          <Box
            component="span"
            key={`${segment.text}-${index}`}
            sx={{
              fontWeight: 700,
              color: 'text.primary',
              bgcolor: (theme) => `${theme.palette.warning.main}33`,
              borderRadius: '2px',
            }}
          >
            {segment.text}
          </Box>
        ) : (
          <React.Fragment key={`${segment.text}-${index}`}>
            {segment.text}
          </React.Fragment>
        )
      )}
    </Typography>
  );
};
